export const OTHER = 'other';
export const UNKNOWN_VRP = 'UNKNOWN_ER';
export enum VehiclesTypes {
  'truck' = 'truck',
  'empty_truck' = 'empty_truck',
  'car' = 'car',
}
export const ERROR = 'error';
export const INTRERPOLATION = 'interpolation';
